function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';
import { components } from 'react-select';
import { makeStyles } from '@material-ui/styles';
var useStyle = makeStyles({
  base: {
    minWidth: '50px',
    '&:focus': {
      outline: 'none'
    }
  }
});
export var SelectContainer = function SelectContainer(_ref) {
  var children = _ref.children,
      selectProps = _ref.selectProps,
      props = _objectWithoutProperties(_ref, ["children", "selectProps"]);

  var classes = useStyle();
  return /*#__PURE__*/React.createElement("div", {
    name: selectProps.name,
    tabIndex: Math.floor(Math.random() * 80),
    className: classes.base
  }, /*#__PURE__*/React.createElement(components.SelectContainer, props, children));
};